import { render } from "./VehicleTypeDisplay.vue?vue&type=template&id=42da1fe1"
import script from "./VehicleTypeDisplay.vue?vue&type=script&lang=js"
export * from "./VehicleTypeDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__